// context/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { setTokens } from "./AxiosInstance";
import { useLocation, useNavigate } from "react-router-dom";
import config from '../Configurations/APIConfig';
import apiService from "../Configurations/APIService";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const mapProfile = (profile) => ({
    id: profile.userId,
    cid: profile.companyId,
    bid: profile.branchId,
    role: profile.roleName,
    name: profile.name,
  });

  useEffect(() => {
    let isMounted = true;

    const restoreSession = async () => {
      const refreshToken = localStorage.getItem("refreshToken");
      const accessToken = localStorage.getItem("accessToken");
      if (!refreshToken || !accessToken) {
        if (isMounted) setLoading(false);
        return;
      }

      try {
        // Try the existing access token first — most refreshes happen with a
        // still-valid token, so this avoids hitting /auth/refresh every time.
        const profile = await apiService.getSingle(config.GETUSERPROFILE, false);
        if (isMounted) setUser(mapProfile(profile));
      } catch (profileErr) {
        try {
          const res = await apiService.post(config.REFRESH, { refreshToken }, false);
          setTokens({
            accessToken: res.accessToken,
            refreshToken: res.refreshToken || refreshToken, // keep rotated token if backend issues one
          });

          const profile = await apiService.getSingle(config.GETUSERPROFILE, false);
          if (isMounted) setUser(mapProfile(profile));
        } catch (refreshErr) {
          console.error("Session restore failed:", refreshErr);
          if (isMounted) await logout();
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    restoreSession();
    return () => {
      isMounted = false;
    };
  }, []);
  const login = async ({ accessToken, refreshToken }) => {
    if (!accessToken || !refreshToken) {
      console.error("Missing accessToken or refreshToken");
      return;
    }
    // 🔐 Store both tokens
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    setTokens({
      accessToken: accessToken,
      refreshToken: refreshToken,
    });
    const profile = await apiService.getSingle(config.GETUSERPROFILE);
    setUser(mapProfile(profile));

    navigate("/flight/search");
  };
  const logout = async () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setUser(null);
    navigate("/", { replace: true });
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);